export default "__VITE_ASSET__JVIO3Jit__"